export default __webpack_public_path__ + "static/media/email.97f9324f.png";